import { useEffect } from "react";
import { Instagram } from "lucide-react";
import { Reveal } from "../components/Reveal";

const POSTS = [
  "https://www.instagram.com/p/DWfzfnND1Gl/",
  "https://www.instagram.com/p/DW0adevlK1F/",
  "https://www.instagram.com/p/DYEGk8kExOy/",
];

const PROFILE_URL = "https://www.instagram.com/iicseh";

export const InstagramSection = () => {
  useEffect(() => {
    const process = () => window.instgrm?.Embeds?.process();
    if (document.querySelector('script[src*="instagram.com/embed.js"]')) {
      process();
      return;
    }
    const s = document.createElement("script");
    s.src = "//www.instagram.com/embed.js";
    s.async = true;
    s.onload = process;
    document.body.appendChild(s);
  }, []);

  return (
    <section className="py-24 sm:py-32" style={{ background: "var(--bg-primary)" }} data-testid="instagram-section">
      <div className="max-w-6xl mx-auto px-5">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase" style={{ color: "var(--accent)" }}>
            <span className="w-5 h-px" style={{ background: "var(--accent)" }} />
            See It For Yourself
            <span className="w-5 h-px" style={{ background: "var(--accent)" }} />
          </span>
          <h2 className="font-display mt-3 text-3xl md:text-4xl font-semibold uppercase text-white leading-[1.12]" data-testid="instagram-headline">
            Life <span className="glow-accent" style={{ color: "var(--accent)" }}>Inside</span> Our Institute
          </h2>
          <p className="mt-4 text-base md:text-lg" style={{ color: "var(--text-body)" }}>
            A real look at our classes, students, and community — straight from Instagram.
          </p>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {POSTS.map((url, i) => (
            <Reveal key={url} delay={i * 100}>
              <div className="track-card h-full rounded-2xl p-4 sm:p-5 flex flex-col" style={{ background: "var(--bg-card)", border: "1px solid var(--input-border)" }} data-testid={`instagram-card-${i}`}>
                <blockquote
                  className="instagram-media"
                  data-instgrm-permalink={url}
                  data-instgrm-version="14"
                  style={{ width: "100%", margin: 0, padding: 0, background: "transparent", border: "none", boxShadow: "none" }}
                />
                <a
                  data-testid={`instagram-fallback-${i}`}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center justify-center gap-2 text-xs font-semibold transition-colors hover:text-white"
                  style={{ color: "var(--accent)" }}
                >
                  <Instagram size={14} />
                  View on Instagram
                </a>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={200} className="mt-10 text-center">
          <a
            data-testid="instagram-follow-button"
            href={PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button inline-flex items-center gap-2 rounded-full px-8 py-4 text-base font-bold"
          >
            <Instagram size={18} />
            Follow Us on Instagram
          </a>
        </Reveal>
      </div>
    </section>
  );
};
